import { apiClient } from "../config";

async function getBrand(brandId: any) {
    const res = await apiClient.get(`/admin/brands/${brandId}`);
    return res.data;
}

export default getBrand;
